<template>
    <div class="msgrow" :class="{unread: !message.read, flagged: message.flagged,
         answered: message.answered, selected: selected, deleted: message.deleted, lastSelected: lastSelected,
         keyboardSelect: keyboardSelect }" :style="colourisation" role="row"
            :aria-selected="selected"
         :id="`msglist-${index}`">
        <div class="kbdselector" @click.stop="toggleSelect">
            <font-awesome-icon icon="arrow-circle-right" size="lg"/>
        </div>
        <div class="selectbox" @click.stop="toggleSelect">
            <font-awesome-icon :icon="selectedIcon"  :size="$mqIs('md+') ? 'lg' : '2x'"/>
        </div>
        <div class="flagbox">
            <font-awesome-icon :icon="flaggedIcon" class="flag" size="lg" @click.stop="toggleFlag"/>
        </div>
        <div class="addresses" @click="doClick">
            {{addresses}}
        </div>
        <div class="subject"  @click="doClick">
            <font-awesome-icon :icon="['fal', 'paperclip']" v-if="message.attachments"></font-awesome-icon>
            {{subject}}
        </div>
        <div class="datetime"  @click="doClick">
            {{time}}
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import libmime from 'libmime';
import { DateTime } from 'luxon';
import axios from 'axios';
import trim from 'lodash/trim';
import parseAddrs from '@/helpers/parseAddrs';

export default {
  name: 'messageLine',
  components: { FontAwesomeIcon },
  props: {
    index: Number,
    folder: Number,
    message: Object,
    selected: Boolean,
    lastSelected: Boolean,
    keyboardSelect: Boolean,
    sentFolder: Boolean
  },
  methods: {
    toggleFlag() {
      if (!this.message.deleted) {
        const uid = this.message.uid;
        const folderId = this.folder;
        axios
          .patch(`/rest/user/folders/${folderId}/${uid}`, { flagged: !this.message.flagged })
          .then(d => {
            console.log('toggleFlag', d);
            this.$emit('messageUpdated', { folderId, uid, newValues: d.data.msg });
          });
      }
    },
    toggleSelect(evt) {
      if (!this.message.deleted) {
        this.$emit('selectMessage', { folder: this.folder, uid: this.message.uid, shift: evt.shiftKey });
      }
    },
    doClick(evt) {
      if (!this.message.deleted) {
        this.$emit('click');
        this.$emit('show', evt);
      }
    }
  },
  computed: {
    addresses() {
      if (this.sentFolder) {
        const x = parseAddrs(this.message.tolist);
        return x.map(r => r.name).join(', ');
      } else {
        let from = libmime.decodeWords(trim(this.message.fromname));
        let m;
        if ((m = /^"(.*)"$/.exec(from)) !== null) {
          from = m[1];
        }
        if (from === '') {
          from = this.message.from;
        }
        return from;
      }
    },
    colourisation() {
      if (this.folder === -2) {
        console.log('score', this.message.spamscore, this.$store.state.settings.quarantine_2);
        if (this.message.spamscore < this.$store.state.settings.quarantine_1) {
          return { color: this.$store.state.settings.quarantine_col0 };
        } else if (this.message.spamscore < this.$store.state.settings.quarantine_2) {
          return { color: this.$store.state.settings.quarantine_col1 };
        } else if (this.message.spamscore < this.$store.state.settings.quarantine_3) {
          return { color: this.$store.state.settings.quarantine_col2 };
        } else {
          return { color: this.$store.state.settings.quarantine_col3 };
        }
      } else {
        return {};
      }
    },
    subject() {
      return libmime.decodeWords(this.message.subject);
    },
    time() {
      const dt = DateTime.fromISO(this.message.msgtime).setZone('local');
      const now = DateTime.local();
      if (now.hasSame(dt, 'day')) {
        return dt.toFormat('H:mm');
      } else {
        if (now.hasSame(dt, 'year')) {
          return dt.toLocaleString({ month: 'short', day: 'numeric' });
        } else {
          return dt.toLocaleString({ month: 'short', day: 'numeric', year: '2-digit' });
        }
      }
    },
    flaggedIcon() {
      return this.message.flagged ? 'star' : ['fal', 'star'];
    },
    selectedIcon() {
      return this.selected ? ['far', 'check-square'] : ['far', 'square'];
    }
  }
};
</script>

<style lang="scss">
    .normalfolder .msgrow {
        &.deleted {
            opacity: 0.3;
            cursor: no-drop !important;
            div {
                cursor: no-drop !important;
            }
        }
    }
    .outboxfolder .msgrow {
        &.deleted {
            text-decoration: line-through;
        }
    }

    .outboxfolder, .quarantinefolder {
        .msgrow .flagbox {
            display: none;
        }
    }

    .messagelist2.size-sm {
        .msgrow {
            grid-template-columns: 0 30px 20px 1fr 8em;
            grid-template-areas: "kbd select flag subject subject"
            "blank select addresses addresses datetime";
        }
    }
</style>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .msgrow {
        user-select: none;
        border: 1px solid rgba(0, 0, 0, 0);
        border-bottom: $message-bottomborder;
        padding: 0.2em 0 0.2em 0;
        display: grid;
        grid-template-columns: 20px 20px 20px 30% 1fr 6em;
        grid-template-areas: "kbd select flag addresses subject datetime";
        &.size-sm {

        }
        div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.selectbox, &.flagbox {
                color: $gray-500;
                flex: 0 0 20px;
                cursor: pointer;
                &.selectbox {
                    grid-area: select;
                }
                &.flagbox {
                    grid-area: flag;
                }
            }
            &.addresses {
                flex: 1 30%;
                cursor: pointer;
                grid-area: addresses;
            }
            &.subject {
                flex: 1 40%;
                cursor: pointer;
                grid-area: subject;
            }
            &.datetime {
                flex: 0 0 6em;
                grid-area: datetime;
                cursor: pointer;
            }
            &.options {
                flex: 0 0 0;
                cursor: pointer;
            }
        }
        &.blue {
            color: blue;
        }
        &.unread {
            font-weight: bold;
        }
        .selectbox {
            text-align: center;
        }
        &.selected .selectbox {
            color: $gray-800;
        }
        &.lastSelected .selectbox {
            color: $black;
            filter: drop-shadow(0px 0px 5px $gray-800);
        }

        &.flagged {
            background-color: $flaggedmessage-bg;
            .flagbox {
                color: $flaggedstar;
            }
        }
        &:hover:not(.deleted) {
            font-size: 1.05em;
            border: 1px solid $gray-400;
            box-shadow: 0px 0px 5px $gray-400;
            padding-bottom: 0.15em;
        }
        .kbdselector {
            opacity: 0;
        }
        &.keyboardSelect {
            .kbdselector {
                opacity: 1;
                color: $red;
            }
        }
    }

</style>
